import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Component, computed, Input, model, ViewChild } from '@angular/core';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.css',
  imports: [CommonModule, FormsModule, CalendarModule, DatePickerModule, FloatLabelModule],
})
export class CalendarComponent {
  /** Etiqueta del input */
  @Input() etiqueta = 'Inserte etiqueta';
  /** Placeholder del input */
  @Input() placeholder = 'Inserte placeholder';
  /** Opción seleccionada */
  valor = model<any>();

  today = new Date();
  private readonly esLocale = {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Limpiar',
    dateFormat: 'dd/mm/yy',
  };
  
  @Input() id = '';
  @Input() minDate: Date | undefined;
  @Input() maxDate: Date | undefined;
  @Input() defaultDate?: Date;
  @Input() locale = this.esLocale;
  @Input() dateFormat = 'dd/mm/yy';

  /** Muestra o no las animaciones del componente */
  show = false;

  @Input() showClear = false;
  @Input() showIcon = false;
  @Input() showTime = false;
  @Input() timeOnly = false;

  /** Permite linkear una variable bool, para mostrar los mensajes de error, desaparece si el usuario
   * ingresa el valor */
  @Input() showError = false;
  @Input() mensajeError = '';
  @Input() readonly = false;

  isEmpty = computed(() => !this.valor());
}
